import React, { useEffect } from 'react';
import './App.css';
import NewHeader from './components/NewHeader.js';
import { testBuffer, testAzureStorage } from './testBuffer';

// App component is now just a layout component that accepts children
function App({ children }) {
  useEffect(() => {
    // Run tests to verify Buffer polyfill is working
    console.log("Running Buffer and Azure Storage tests...");
    const bufferResult = testBuffer();
    const azureResult = testAzureStorage("testaccount", "?sv=2020-08-04&ss=b&srt=sco&sp=rwdlacx&se=2025-12-31T00:00:00Z&st=2025-01-01T00:00:00Z&spr=https&sig=testSignature");
    
    console.log("Buffer test result:", bufferResult ? "PASSED" : "FAILED");
    console.log("Azure Storage test result:", azureResult ? "PASSED" : "FAILED");
  }, []);

  return (
    <div className="app">
      <NewHeader />
      <div className="main-container">
        <main className="content">
          {children}
        </main>
      </div>
    </div>
  );
}

export default App;
